import type { ActiveRoom } from '@patrianna/shared-patrianna-types/store/BingoModule'
import type { GameProductShort, ProductModes } from '@patrianna/shared-patrianna-types/store/GameModule'

export type BingoRoom = GameProductShort & { mode: ProductModes; nextGameStart: number }

export type BingoRoomJackpot = {
  jackpotPrize: string
  currency: string
  bingoType?: string
  gameKey?: string
}

export type BingoTypeJackpots = {
  GC?: BingoRoomJackpot
  SC?: BingoRoomJackpot
}

export const getGameKeyFromName = (name: string): string => name.replace(/\s+(GC|SC)$/i, '').trim()

export type BingoRoomWs = {
  bingoType: string
  currency: string
  gamePrize: string
  jackpotPrize: string
  name: string
  nextRoundTime: string
  roomId: string
  ticketPrice: string
}

export type BingoRoomsResponseBody = {
  type: 'BingoRoomsResponse'
  bingoRooms: BingoRoomWs[]
}

// Declare state types with `readonly` modifier to get compile time immutability.
// https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
export interface BingoState {
  readonly products: Array<GameProductShort> | null
  readonly rooms: Array<ActiveRoom> | null
  readonly bingoRoomsJackpots: Record<string, BingoRoomJackpot>
  readonly gameJackpots: Record<string, BingoTypeJackpots>
}
